<i *ngIf="!this.form" class="material-icons rotate text-muted">loop</i>
<form class="card mt-2" [formGroup]="form" *ngIf="this.form">
  <div class="card-body">
    <h4 class="mb-3">Request Med Clinic Services</h4>
    <div class="row">
      <div class="col-12 col-xl-6 ">


        <div class="row">
          <div class="col-4 d-flex align-items-center">
            <b>Relationship</b>
          </div>
          <div class="col-8">
            <p-select styleClass="app-select mt-2 w-100" [disabled]="disableForm" [options]="relationshipOptions" (onChange)="relationshipChange($event)" placeholder="Select relationship..." formControlName="relationshipToClient"></p-select>
            <app-validation-message [form]="form" [path]="'relationshipToClient'" [name]="'relationshipToClient'" [label]="'Relationship To Client'"> </app-validation-message>
          </div>
        </div>

        <div class="row">
          <div class="col-4 d-flex align-items-center">
            <b>Birthdate</b>
          </div>
          <div class="col-8">
            <input type="date" class="form-control mt-2" [readonly]="disableForm" formControlName="birthdate" />
            <app-validation-message [form]="form" [path]="'birthdate'" [name]="'birthdate'" [label]="'Birthdate'"> </app-validation-message>
          </div>
        </div>

        <div class="row" >
          <div class="col-4 d-flex align-items-center">
            <b>Personal Email</b>
            <i class="fas fa-info-circle ml-2" [escape]="false" pTooltip="Family members 18 years of age or older require their own email address and client portal login."></i>
          </div>
          <div class="col-8">
            <input type="text" class="form-control mt-2" [readonly]="disableForm" formControlName="email" />
               <app-validation-message [form]="form" [path]="'email'" [name]="'email'" [label]="'Email'"> </app-validation-message>
          </div>
        </div>

        <ng-container *ngIf="this.form.get('relationshipToClient').value !== 'Self'">
          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>First Name</b>
            </div>
            <div class="col-8">
              <input type="text" class="form-control mt-2" [readonly]="disableForm" formControlName="firstName" />
              <app-validation-message [form]="form" [path]="'firstName'" [name]="'firstName'" [label]="'First Name'"> </app-validation-message>
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Middle Name</b>
            </div>
            <div class="col-8">
              <input type="text" class="form-control mt-2" [readonly]="disableForm" formControlName="middleName" />
              <app-validation-message [form]="form" [path]="'middleName'" [name]="'middleName'" [label]="'Middle Name'"> </app-validation-message>
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Last Name</b>
            </div>
            <div class="col-8">
              <input type="text" class="form-control mt-2" [readonly]="disableForm" formControlName="lastName" />
              <app-validation-message [form]="form" [path]="'lastName'" [name]="'lastName'" [label]="'Last Name'"> </app-validation-message>
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Gender</b>
            </div>
            <div class="col-8">
              <p-select styleClass="app-select mt-2 w-100" [disabled]="disableForm" [options]="genderOptions" placeholder="Select gender..." formControlName="gender"></p-select>
              <app-validation-message [form]="form" [path]="'gender'" [name]="'gender'" [label]="'Gender'"> </app-validation-message>
            </div>
          </div>
        </ng-container>

        <div class="row">
          <div class="col-4 d-flex align-items-center">
            <b>Services</b>
          </div>
          <div class="col-8 pt-2 pb-2">
            <!--<p-checkbox    formControlName="isMedClinic" [binary]="true" [disabled]="disableForm" ></p-checkbox>
            Primary Care-->
            <p-checkbox formControlName="isPsychMed" [binary]="true" [disabled]="disableForm" ></p-checkbox>
            Psych Med
            <app-validation-message [form]="form" [path]="'isMedClinic'" [name]="'isMedClinic'" [label]="'Med Clinic'"> </app-validation-message>
          </div>
        </div>
        <div class="row">
          <div class="col-4 d-flex align-items-center">
            <b>Reason for inquiry</b>
          </div>
          <div class="col-8">
            <textarea  class="form-control mt-2" formControlName="reasonForInquiry" [readonly]="disableForm" ></textarea>
            <app-validation-message [form]="form" [path]="'reasonForInquiry'" [name]="'reasonForInquiry'" [label]="'ReasonForInquiry'"> </app-validation-message>
          </div>
        </div>
      </div>
      <div class="col-12 col-xl-6 ">



        <ng-container >

          <div class="row">
            <div class="col-12 ">
              <h4>Insurance Provider (Optional)</h4>
              <small>You can optionally add an additional insurance provider to be used for your Med Clinic services.</small>
            </div>
          </div>
          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Insurance Provider</b>
            </div>
            <div class="col-8">
              <p-select styleClass="app-select mt-2 w-100" [disabled]="disableForm" [options]="insuranceProvidersOptions"  placeholder="Select provider..." formControlName="insuranceProviderID"></p-select>
                <app-validation-message [form]="form" [path]="'insuranceProviderID'" [name]="'insuranceProviderID'" [label]="'Insurance Provider'"> </app-validation-message>
            </div>
          </div>
          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Policy Holder First Name</b>
            </div>
            <div class="col-8">
              <input type="text" class="form-control mt-2" [readonly]="disableForm" formControlName="policyHolderFirstName" />
              <app-validation-message [form]="form" [path]="'policyHolderFirstName'" [name]="'policyHolderFirstName'" [label]="'Policy Holder First Name To Client'"> </app-validation-message>
            </div>
          </div>
            <div class="row">
              <div class="col-4 d-flex align-items-center">
                <b>Policy Holder Last Name</b>
              </div>
              <div class="col-8">
                <input type="text" class="form-control mt-2" [readonly]="disableForm" formControlName="policyHolderLastName" />
                <app-validation-message [form]="form" [path]="'policyHolderLastName'" [name]="'policyHolderLastName'" [label]="'Policy Holder Last Name'"> </app-validation-message>
              </div>
            </div>

            <div class="row">
              <div class="col-4 d-flex align-items-center">
                <b>Policy Holder's Birth Date</b>
              </div>
              <div class="col-8">
                <input type="date" class="form-control mt-2" [readonly]="disableForm" formControlName="policyHolderDoB" />
                <app-validation-message [form]="form" [path]="'policyHolderDoB'" [name]="'policyHolderDoB'" [label]="'Birthdate'"> </app-validation-message>
              </div>
            </div>

            <div class="row">
              <div class="col-4 d-flex align-items-center">
                <b>Member ID</b>
              </div>
              <div class="col-8">
                <input type="text" class="form-control mt-2" [readonly]="disableForm" formControlName="memberID" />
                <app-validation-message [form]="form" [path]="'memberID'" [name]="'memberID'" [label]="'Member ID'"> </app-validation-message>
              </div>
            </div>
            <div class="row">
              <div class="col-4 d-flex align-items-center">
                <b>Group ID</b>
              </div>
              <div class="col-8">
                <input type="text" class="form-control mt-2" [readonly]="disableForm" formControlName="policyNumber" />
                <app-validation-message [form]="form" [path]="'policyNumber'" [name]="'policyNumber'" [label]="'Group ID'"> </app-validation-message>
              </div>
            </div>

            <div class="row">
              <div class="col-4 d-flex align-items-center">
                <b>Start Date</b>
              </div>
              <div class="col-8">
                <input type="date" class="form-control mt-2" [readonly]="disableForm" formControlName="startDate" />
                <app-validation-message [form]="form" [path]="'startDate'" [name]="'startDate'" [label]="'Start Date'"> </app-validation-message>
              </div>
            </div>

            <div class="row">

              <div class="col-4 d-flex align-items-center">
                <b>Expiration Date</b>
              </div>
              <div class="col-8">
                <input type="date" class="form-control mt-2" [readonly]="disableForm" formControlName="expirationDate" />
                <app-validation-message [form]="form" [path]="'expirationDate'" [name]="'expirationDate'" [label]="'Expiration Date'"> </app-validation-message>
              </div>
            </div>
          </ng-container>
      </div>
    </div>
    <div class="row" style="margin-right: 0; margin-left: 0;" *ngIf="duplicates.length > 0">
      <h4 class="mb-3">Possible Duplicates</h4>
      <p-table [value]="duplicates" [responsive]="true"
               [paginator]="false">
        <ng-template pTemplate="header">
          <tr>
            <th>Name</th>
            <th>Preferred Name</th>
            <th>Birthdate</th>
            <th>Gender</th>
            <th>Email</th>

          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-patient>
          <tr>
            <td>
              <span class="ui-column-title">Name</span>
              {{patient.name }}
            </td>
            <td>
              <span class="ui-column-title">Preferred Name</span>
              {{patient.preferredName }}
            </td>

            <td>
              <span class="ui-column-title">Birthdate</span>
              {{patient.birthdate}}
            </td>
            <td>
              <span class="ui-column-title">Gender</span>
              {{patient.gender}}
            </td>

            <td>
              <span class="ui-column-title">Email</span>
              {{patient.email}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="row">
      <div class="mt-4 float-right">
        <i *ngIf="creatingPatient" class="material-icons rotate text-muted">loop</i>
        <button *ngIf="!creatingPatient && duplicates.length == 0" class="btn btn-primary" [class.disabled]="form.invalid" (click)="checkForDuplicates()">Save</button>
        <button *ngIf="!creatingPatient && duplicates.length > 0" class="btn btn-secondary mr-2" [class.disabled]="form.invalid" (click)="editRequest()">Edit Request</button>
        <button *ngIf="!creatingPatient && duplicates.length > 0" class="btn btn-primary" [class.disabled]="form.invalid" (click)="save()">Save</button>
      </div>
    </div>
  </div>
</form>
